import { useMemo } from 'react';
import { object } from 'yup';
import { Button, Stack } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

import { IPackage } from 'api';
import { getPackagesApi } from 'api/packages/query';
import { ArrowRightIcon } from 'components/v2/icons/ArrowRightIcon';
import { CurrencyCode } from 'constants/enums/general';
import { useLocalization } from 'localization';
import { createAdsCampaignOrderStore } from 'stores/createAdsCampaignOrderStore';

export const useCreateAdsCampaignOrderStep1 = () => {
  const { t, f } = useLocalization();
  const { goToStep } = createAdsCampaignOrderStore();

  const formSchema = object().shape({});

  const { data, isLoading } = getPackagesApi({
    branchId: 'a97e819a-f530-48e3-8114-ac896138b5f8',
    packageType: 'property' as any,
    textSearch: '',
  });

  const handleChooseCase = (row: IPackage) => {
    goToStep(2);
  };

  const packagesColumns = useMemo(() => {
    return [
      {
        headerName: t('orders.pages.new.flowSelection.packageName'),
        field: 'name',
        minWidth: 500,
        sortable: false,
        flex: 1,
        renderCell: (params: GridRenderCellParams<IPackage, IPackage['name']>) => {
          const { value, row } = params;
          return (
            <Stack direction="row" spacing={2} alignItems="center">
              <img src={row?.thumbnail} alt={value} width={80} height={80} style={{ borderRadius: 8 }} />
              <p>{value}</p>
            </Stack>
          );
        },
      },
      {
        headerName: t('common.terms.price'),
        field: 'totalPrice',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams<IPackage, IPackage['totalPrice']>) => {
          const { value, row } = params;
          const packageCurrency = row?.currency ?? row.products?.find(({ currency }) => !!currency)?.currency;
          return value ? f(value || 0, { currency: packageCurrency || CurrencyCode.DKK, decimals: 2 }) : '-';
        },
      },
      {
        headerName: t('common.terms.actions'),
        field: 'id',
        key: 'actions',
        width: 260,
        sortable: false,
        renderCell: (params: GridRenderCellParams<IPackage, IPackage['id']>) => {
          const { value: id, row } = params;
          return (
            <Button
              variant="contained"
              size="medium"
              endIcon={<ArrowRightIcon />}
              onClick={() => handleChooseCase(row)}
            >
              {t('orders.pages.new.ads.startSetup')}
            </Button>
          );
        },
      },
    ];
  }, [t, f]);
  return {
    form: { schema: formSchema },
    serverState: { data, isLoading },
    ui: {
      table: {
        columns: packagesColumns,
      },
    },
  };
};
